import createIcon from '../../createIcon';

/**
 * @component @name Fax
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOC41SDE4VjMuNUg4VjE5LjVIMjJWMTEuNUMyMiA5Ljg0IDIwLjY2IDguNSAxOSA4LjVaTTEwIDUuNUgxNlY4LjVIMTBWNS41Wk0xNCAxNi41SDEwVjExLjVIMTRWMTYuNVpNMTYgMTYuNUMxNS40NSAxNi41IDE1IDE2LjA1IDE1IDE1LjVDMTUgMTQuOTUgMTUuNDUgMTQuNSAxNiAxNC41QzE2LjU1IDE0LjUgMTcgMTQuOTUgMTcgMTUuNUMxNyAxNi4wNSAxNi41NSAxNi41IDE2IDE2LjVaTTE2IDEzLjVDMTUuNDUgMTMuNSAxNSAxMy4wNSAxNSAxMi41QzE1IDExLjk1IDE1LjQ1IDExLjUgMTYgMTEuNUMxNi41NSAxMS41IDE3IDExLjk1IDE3IDEyLjVDMTcgMTMuMDUgMTYuNTUgMTMuNSAxNiAxMy41Wk0xOSAxNi41QzE4LjQ1IDE2LjUgMTggMTYuMDUgMTggMTUuNUMxOCAxNC45NSAxOC40NSAxNC41IDE5IDE0LjVDMTkuNTUgMTQuNSAyMCAxNC45NSAyMCAxNS41QzIwIDE2LjA1IDE5LjU1IDE2LjUgMTkgMTYuNVpNMTkgMTMuNUMxOC40NSAxMy41IDE4IDEzLjA1IDE4IDEyLjVDMTggMTEuOTUgMTguNDUgMTEuNSAxOSAxMS41QzE5LjU1IDExLjUgMjAgMTEuOTUgMjAgMTIuNUMyMCAxMy4wNSAxOS41NSAxMy41IDE5IDEzLjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNC41IDcuNUMzLjEyIDcuNSAyIDguNjIgMiAxMFYxOEMyIDE5LjM4IDMuMTIgMjAuNSA0LjUgMjAuNUM1Ljg4IDIwLjUgNyAxOS4zOCA3IDE4VjEwQzcgOC42MiA1Ljg4IDcuNSA0LjUgNy41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fax = createIcon('Fax', [
  [
    'path',
    {
      d: 'M19 8.5H18V3.5H8V19.5H22V11.5C22 9.84 20.66 8.5 19 8.5ZM10 5.5H16V8.5H10V5.5ZM14 16.5H10V11.5H14V16.5ZM16 16.5C15.45 16.5 15 16.05 15 15.5C15 14.95 15.45 14.5 16 14.5C16.55 14.5 17 14.95 17 15.5C17 16.05 16.55 16.5 16 16.5ZM16 13.5C15.45 13.5 15 13.05 15 12.5C15 11.95 15.45 11.5 16 11.5C16.55 11.5 17 11.95 17 12.5C17 13.05 16.55 13.5 16 13.5ZM19 16.5C18.45 16.5 18 16.05 18 15.5C18 14.95 18.45 14.5 19 14.5C19.55 14.5 20 14.95 20 15.5C20 16.05 19.55 16.5 19 16.5ZM19 13.5C18.45 13.5 18 13.05 18 12.5C18 11.95 18.45 11.5 19 11.5C19.55 11.5 20 11.95 20 12.5C20 13.05 19.55 13.5 19 13.5Z',
      key: 'f7nz3p',
    },
  ],
  [
    'path',
    {
      d: 'M4.5 7.5C3.12 7.5 2 8.62 2 10V18C2 19.38 3.12 20.5 4.5 20.5C5.88 20.5 7 19.38 7 18V10C7 8.62 5.88 7.5 4.5 7.5Z',
      key: '1dl6v5',
    },
  ],
]);

export default Fax;
